import React from 'react';

import ManageDepartments from './manage_departments';
import ManagePermissions from './manage_permissions';

import '../../../css/hsms/manage_departments_screen.css';

export default function ManageDepartmentsScreen({ isLoading, subscreenRestricted, subscreenLocked, subscreen, addSupervisorToDepartment, removeSupervisorFromDepartment, openSupervisorsList, closeSupervisorsList, scheduleStructureDataLoading, departments, setDepartments, supervisors, userInfo, schoolInfo, rolePages, setRolePages, handleMoveToNextScreen }) {
	return (
		<div className="school-setup-main-container">
			{isLoading ?
				(
					<div className='center-text'>
						<img src={require('../../../images/balls.gif')} alt='Loading...' style={{height:'40px'}}/>
					</div>
				) :
				(
					<>
					{(() => {
						switch(subscreen) {
							case 'manage_permissions':
								return <ManagePermissions isLoading={isLoading} subscreenRestricted={subscreenRestricted} subscreenLocked={subscreenLocked} subscreen={subscreen} departments={departments} setDepartments={setDepartments} userInfo={userInfo} schoolInfo={schoolInfo} rolePages={rolePages} handleMoveToNextScreen={handleMoveToNextScreen}/>;
							case 'add_supervisors':
							case 'manage_departments':
							default:
								return <ManageDepartments isLoading={isLoading} subscreenRestricted={subscreenRestricted} subscreenLocked={subscreenLocked} subscreen={subscreen} addSupervisorToDepartment={addSupervisorToDepartment} removeSupervisorFromDepartment={removeSupervisorFromDepartment} openSupervisorsList={openSupervisorsList} closeSupervisorsList={closeSupervisorsList} scheduleStructureDataLoading={scheduleStructureDataLoading} departments={departments} setDepartments={setDepartments} supervisors={supervisors} userInfo={userInfo} schoolInfo={schoolInfo} rolePages={rolePages} setRolePages={setRolePages} handleMoveToNextScreen={handleMoveToNextScreen}/>;
						}
					})()}
					</>
				)
			}
		</div>
	);
}
